/**
 * @param {*} value
 * @param {number|null} bank
 * @returns {string|undefined}
 */
function accountNo (value, bank) {
  let val = value
  if (!val) return

  val = val
    .toString()
    .trim()
    .replace(/[^0-9]+/g, '')

  if (!val) return
  if (val.length !== 11) return val

  return val
    .replace(
      /(\d{4})(\d{4})(\d{3})/,
      '$1 $2 $3'
    )
}

module.exports = { accountNo }
